import { apiFetch } from './client'
import type { Team } from '@/types/bracket'

export interface ChampionPick {
  player_id: string
  team_id: string
  picked_at: number
  points_awarded: number
}

export interface ChampionBoardEntry {
  player_id: string
  display_name: string
  is_ai: number
  group_id: string | null
  team_id: string
  team_name: string
  team_flag: string | null
  picked_at: number
  points_awarded: number
}

export interface ChampionBoard {
  champion: string | null
  picks: ChampionBoardEntry[]
}

export const fetchChampionPick = (token: string) =>
  apiFetch<{ pick: ChampionPick | null; teams: Team[] }>('/champion-pick', { token })

export const submitChampionPick = (teamId: string, token: string) =>
  apiFetch<{ ok: boolean }>('/champion-pick', {
    method: 'POST',
    body: JSON.stringify({ teamId }),
    token,
  })

export const fetchChampionBoard = () =>
  apiFetch<ChampionBoard>('/champion-board')
